// extracted by mini-css-extract-plugin
module.exports = {"base":"styles-m__base__1UyKS","contributor-name":"styles-m__contributor-name__2fC6w","icon":"styles-m__icon__2ONhi"};